/**
 * This file is responsible to combine all reducers.
 * All the reducer functions must be passed into combineReducers()
 * */

import { combineReducers } from 'redux'
import vvz from './vvz'

export default combineReducers({
  vvz
})
